import React from 'react';
import DropdownItem from '@/components/DropdownItem';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const TaskTools = ({ category, task }) => {
  const { canClaim, canManage, claimed } = Selectors.useTaskTools({ task });
  const show = Events.useShowRequestTask();
  const manage = Events.useShowManageRequestTask();
  const claim = Events.useClaimRequestTask(category, task);
  return (
    <>
      <DropdownItem icon="edit" textId="actions.open" onClick={() => show({ task })} />
      {canClaim && (
      <DropdownItem
        icon={claimed ? 'remove user' : 'add user'}
        onClick={() => claim({ ...task, silent: false })}
        textId={claimed ? 'actions.unclaim' : 'actions.claim'}
      />
      )}
      {canManage && (<DropdownItem icon="cogs" onClick={() => manage({ task })} textId="actions.manage" />)}
    </>
  );
};

export default TaskTools;
